import {
  fieldProductSelectionOCDR,
  fieldContractTerm,
  fieldOneMonthSubscription,
  fieldMicrosoftCloudAndAdvisoryServices,
  fieldOperatorConnect,
  fieldDirectRouting
} from '../../utils/constant';
import { getFieldValue } from '../utils';

function ProductDetailsSection(formFields, fieldName, fields) {
  const productValue = getFieldValue(fieldProductSelectionOCDR, formFields);

  if (fieldName === fieldProductSelectionOCDR) {
    if (productValue && productValue.includes(fieldDirectRouting)) {
      fields.options = formFields[fieldProductSelectionOCDR].options.filter(
        value => value.fields.value !== fieldOperatorConnect
      );
    } else if (productValue && productValue.includes(fieldOperatorConnect)) {
      fields.options = formFields[fieldProductSelectionOCDR].options.filter(
        value => value.fields.value !== fieldDirectRouting
      );
    } else {
      fields.options = formFields[fieldProductSelectionOCDR].options;
    }
  }

  if (fieldName === fieldContractTerm) {
    if (
      productValue &&
      productValue.includes(fieldMicrosoftCloudAndAdvisoryServices)
    ) {
      fields.options = formFields[fieldContractTerm].options;
    } else {
      fields.options = formFields[fieldContractTerm].options.filter(
        value => value.fields.value !== fieldOneMonthSubscription
      );
    }
  }
}

export default ProductDetailsSection;
